<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Open Space Technology</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="chapter">
<a id="pageii">
<p><br/><br/><br/><br/></p>
<h1><b>    Also by Harrison Owen </b></h1>
<p id="d7e303"><i>Spirit: Transformation and Development in Organizations </i><br/><br/></p>
<p id="d7e353"><i>Leadership Is </i><br/><br/></p>
<p id="d7e403"><i>Riding the Tiger </i><br/><br/></p>
<p id="d7e453"><i>The Millennium Organization </i><br/><br/></p>
<p id="d7e513"><i>Tales From Open Space </i><br/><br/></p>
<p id="d7e563"><i>Expanding Our Now: The Story of Open Space Technology </i><br/><br/></p>
<p id="d7e613"><i>The Power of Spirit: How Organizations Transform </i><br/><br/></p>
<p id="d7e663"><i>The Spirit of Leadership </i><br/><br/></p>
<p id="d7e713"><i>Wave Rider: Leadership for High Performance in a </i><br/><br/></p>
<p id="d7e763"><i>          Self-Organizing World </i><br/><br/></p>
</a></div><a id="pageii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlsobyHarrisonOwen.vue?6e702916